import "./product-carousel-wrapper";

class ProductCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper, Pagination }) => {
      const swiperParams = {
        modules: [Pagination],
        slidesPerView: "auto",
        navigation: {
          nextEl: this.querySelector("[data-product-carousel-navigation-next]"),
          prevEl: this.querySelector(
            "[data-product-carousel-navigation-previous]",
          ),
        },
        pagination: {
          clickable: true,
          enabled: true,
          el: ".swiper-pagination",
        },
        breakpoints: {
          768: {
            pagination: {
              enabled: false,
            },
          },
        },
        on: {
          lock: () => {
            this.classList.add("product-carousel__carousel-wrapper--locked");
          },
          unlock: () => {
            this.classList.remove("product-carousel__carousel-wrapper--locked");
          },
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("product-carousel")) {
  customElements.define("product-carousel", ProductCarousel);
}
